module.exports = __webpack_public_path__ + "static/media/business.3c6bd4fc.png";